<template>
	<v-layout row wrap class="mt-5">
		<template v-if="items.length > 0">
			<v-flex xs12 sm6 md3 v-for="(item, id) of items" :key="id" class="pa-3">
				<v-card>
					<div class="text-xs-center">
						<img :src="item.img" width="100%">
					</div>

					<v-card-title class="headline">{{ item.title }}</v-card-title>

					<v-list dense two-line>
						<v-list-tile v-for="(detail, did) of item.details" :key="did">
							<v-list-tile-action>
								<v-icon>{{ detail.icon }}</v-icon>
							</v-list-tile-action>

							<v-list-tile-content>
								<v-list-tile-title>{{ detail.title }}</v-list-tile-title>
								<v-list-tile-sub-title v-if="detail.description">{{ detail.description }}</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>

						<!--<v-list-tile>
							<v-spacer></v-spacer>
							<v-list-tile-action>
								<v-btn outline :color="$store.getters.getTheme ? 'white' : 'primary'">Detalhes</v-btn>
							</v-list-tile-action>
						</v-list-tile>-->
					</v-list>
				</v-card>
			</v-flex>
		</template>

		<template v-else>
			<v-layout align-center>
				<v-flex v-if="$vuetify.breakpoint.smAndUp" xs1 text-xs-center>
					<v-icon :color="$store.getters.getTheme ? 'white' : 'primary'">clear</v-icon>
				</v-flex>

				<v-flex xs11 class="grey--text">
					Não existem itens para serem mostrados :(
				</v-flex>
			</v-layout>
		</template>
	</v-layout>
</template>

<script>
const portfolio_siscorp =  require('../assets/img/portfolio/siscorp.png')
const portfolio_link =  require('../assets/img/portfolio/link.png')
const portfolio_dt =  require('../assets/img/portfolio/dt.png')
const portfolio_hu3 =  require('../assets/img/portfolio/hu3.png')

export default {
	name: 'portfolio-item',
	data() {
		return {
			items: [
				{
					title: 'SisCORP',
					img: portfolio_siscorp,
					details: [
						{
							icon: 'work',
							title: 'Profissional',
							description: null
						},
						{
							icon: 'timeline',
							title: 'ERP',
							description: 'Sistema corporativo'
						},
						{
							icon: 'code',
							title: 'NodeJS, Express, MySQL, VueJS',
							description: null
						},
						{
							icon: 'desktop_windows smartphone',
							title: 'Desktop & Mobile',
							description: null
						}
					]
				},
				{
					title: 'Link',
					img: portfolio_link,
					details: [
						{
							icon: 'work',
							title: 'Profissional',
							description: null
						},
						{
							icon: 'input',
							title: 'REST',
							description: 'Integração de sistemas'
						},
						{
							icon: 'code',
							title: 'C#, Asp.NET, Firebird',
							description: null
						},
						{
							icon: 'http',
							title: 'REST API',
							description: null
						}
					]
				},
				{
					title: 'Smart Dating',
					img: portfolio_dt,
					details: [
						{
							icon: 'person',
							title: 'Pessoal',
							description: null
						},
						{
							icon: 'cloud',
							title: 'PWA',
							description: 'Controle de encontros'
						},
						{
							icon: 'code',
							title: 'VueJS, Firebase',
							description: null
						},
						{
							icon: 'desktop_windows smartphone',
							title: 'Desktop & Mobile',
							description: null
						}
					]
				},
				{
					title: 'Hu3-Life',
					img: portfolio_hu3,
					details: [
						{
							icon: 'people',
							title: 'Pessoal/Equipe',
							description: null
						},
						{
							icon: 'games',
							title: 'Jogo',
							description: 'Modificação do Half-Life'
						},
						{
							icon: 'code',
							title: 'C++, CMake, Travis, SQLite',
							description: null
						},
						{
							icon: 'desktop_windows',
							title: 'Desktop',
							description: null
						}
					]
				}
			]
		}
	},
	methods: {
	}
}
</script>
